import IconBack from '@/assets/icons/ic_logic-g-app_arrow-left.svg'

import { useRouter } from 'next/router'

import NextHistory from '@/NextHistory'
import { Button } from '@/components/ui/button'
import { cn } from '@/utils/tw-helpers'

interface Props {
  onClick?: () => void
}

export const WebPageBackButton = ({ onClick }: Props): JSX.Element => {
  const router = useRouter()

  const handleClick = () => {
    if (onClick) {
      onClick()
      return
    }

    if (NextHistory.canGoBack()) {
      router.back()
    } else {
      router.push('https://www.sonyged.com/logiq')
    }
  }

  return (
    <div className="relative">
      <Button
        variant="outline"
        className={cn(
          'absolute left-2.5 top-2.5 h-8 rounded-lg pl-5 pr-2.5 text-xs md:left-5 md:h-10 md:justify-start md:rounded-xl md:pl-[38px] md:text-[17px] lg:top-[22px] lg:h-11',
          NextHistory.canGoBack() ? 'w-14 md:w-[92px]' : 'w-[80px] md:w-[126px]'
        )}
        size="sm"
        shadow={false}
        onClick={handleClick}
      >
        <IconBack
          width={24}
          className="absolute left-0 top-1/2 -translate-y-1/2 md:left-2 md:w-[30px]"
        />
        {NextHistory.canGoBack() ? '戻る' : 'トップへ'}
      </Button>
    </div>
  )
}
